"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _UIPaginator = _interopRequireDefault(require("UIComponents/paginator/UIPaginator"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _constants = require("../../../constants");

var FilterKey = _interopRequireWildcard(require("../../../constants/search/FilterKey"));

var _SearchResult = _interopRequireDefault(require("../../../records/SearchResult"));

var _requestState = require("../../../utils/requestState");

var _i18n2 = require("../../../utils/i18n");

var _strings = require("../../../utils/strings");

var _AmplifyHeaderSection = _interopRequireDefault(require("./AmplifyHeaderSection"));

var _ResultsFilters = _interopRequireDefault(require("./ResultsFilters"));

var _ResultsGrid = _interopRequireDefault(require("./ResultsGrid"));

var _ResultsSection = _interopRequireDefault(require("./ResultsSection"));

var _SortDropdown = _interopRequireDefault(require("./SortDropdown"));

var _ScrollToResults = _interopRequireDefault(require("./ScrollToResults"));

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.results.resultsPage." + key;
};

var getFiltersHeadingI18nKey = function getFiltersHeadingI18nKey(filters) {
  var collection = filters[FilterKey.COLLECTION],
      superCategory = filters[FilterKey.SUPER_CATEGORY],
      category = filters[FilterKey.CATEGORY];

  if (collection) {
    return (0, _i18n2.getCollectionI18nKey)(collection);
  } else if (category) {
    return (0, _i18n.getCategoryI18nKey)(category);
  } else if (superCategory) {
    return (0, _i18n.getSuperCategoryI18nKey)(superCategory);
  }

  return getI18nKey('headingText.allCategories');
};

var SupplementalResultsSection = function SupplementalResultsSection(_ref) {
  var onResultClick = _ref.onResultClick,
      resultProps = _ref.resultProps,
      searchResult = _ref.searchResult;
  var filters = searchResult.filters,
      items = searchResult.items,
      total = searchResult.total;
  var resultsLength = items.size;
  var filtersHeadingI18nKey = (0, _react.useMemo)(function () {
    return getFiltersHeadingI18nKey(filters);
  }, [filters]);
  var superCategory = filters[FilterKey.SUPER_CATEGORY],
      category = filters[FilterKey.CATEGORY],
      collection = filters[FilterKey.COLLECTION];
  var renderedTitle = (0, _react.useMemo)(function () {
    if (category || superCategory) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('supplementalResults.categoryResults.headingText'),
        options: {
          category: (0, _unescapedText.default)(filtersHeadingI18nKey)
        }
      });
    }

    return _react.default.createElement(_FormattedMessage.default, {
      message: filtersHeadingI18nKey
    });
  }, [category, filtersHeadingI18nKey, superCategory]);
  var renderedSubheading = (0, _react.useMemo)(function () {
    if (category || superCategory) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('supplementalResults.categoryResults.subheadingText'),
        options: {
          category: (0, _unescapedText.default)(filtersHeadingI18nKey)
        }
      });
    }

    if (collection) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: (0, _i18n2.getCollectionI18nKey)(collection, 'subheadingText')
      });
    }

    return null;
  }, [category, collection, filtersHeadingI18nKey, superCategory]);
  var renderedSeeAllLink = (0, _react.useMemo)(function () {
    if (total <= resultsLength) {
      return null;
    }

    return _react.default.createElement(_UIRouterLink.default, {
      to: filters.toLocation()
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('supplementalResults.seeAllLinkText')
    }));
  }, [filters, resultsLength, total]);

  if (items.isEmpty()) {
    return null;
  }

  return _react.default.createElement(_ResultsSection.default, null, _react.default.createElement(_UISubheader.default, {
    className: "p-bottom-0",
    details: renderedSubheading,
    headingLevel: "h4",
    title: renderedTitle
  }, renderedSeeAllLink), _react.default.createElement(_ResultsGrid.default, {
    onResultClick: onResultClick,
    resultProps: resultProps,
    results: items
  }));
};

var ResultsPage = function ResultsPage(_ref2) {
  var activePage = _ref2.activePage,
      FailedComponent = _ref2.failedComponent,
      filters = _ref2.filters,
      offset = _ref2.offset,
      onClearFilters = _ref2.onClearFilters,
      onFilterChange = _ref2.onFilterChange,
      onPageChange = _ref2.onPageChange,
      _onResultClick = _ref2.onResultClick,
      onSortChange = _ref2.onSortChange,
      requestState = _ref2.requestState,
      resultProps = _ref2.resultProps,
      resultsPerPage = _ref2.resultsPerPage,
      searchResult = _ref2.searchResult,
      supplementalResults = _ref2.supplementalResults,
      trackInteraction = _ref2.trackInteraction;
  var collection = filters[FilterKey.COLLECTION],
      superCategory = filters[FilterKey.SUPER_CATEGORY],
      category = filters[FilterKey.CATEGORY],
      searchValue = filters[FilterKey.SEARCH];
  var resultsRef = (0, _react.useRef)(null);
  var searchResults = searchResult.items,
      searchResultsTotal = searchResult.total;
  var searchResultsLength = searchResults.size;
  var hasResults = !!searchResultsTotal; // TODO cleanup/refactor

  var _useMemo = (0, _react.useMemo)(function () {
    if (category || superCategory) {
      return [supplementalResults.first(), supplementalResults.rest()];
    }

    return [undefined, supplementalResults];
  }, [category, superCategory, supplementalResults]),
      _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
      _useMemo2$ = _useMemo2[0],
      allCategoriesResult = _useMemo2$ === void 0 ? new _SearchResult.default() : _useMemo2$,
      restSupplementalResults = _useMemo2[1];

  var allCategoriesFilters = allCategoriesResult.filters,
      allCategoriesResults = allCategoriesResult.items,
      allCategoriesTotal = allCategoriesResult.total;
  var allCategoriesResultsLength = allCategoriesResults.size;
  var hasAllCategoriesResults = !!allCategoriesTotal;
  var showAllCategoriesSearchResults = !!(searchValue && !hasResults && hasAllCategoriesResults);
  var handlePageChange = (0, _react.useCallback)(function (_ref3) {
    var value = _ref3.target.value;
    onPageChange(value, showAllCategoriesSearchResults ? allCategoriesFilters : filters);
  }, [allCategoriesFilters, filters, onPageChange, showAllCategoriesSearchResults]);

  var _useMemo3 = (0, _react.useMemo)(function () {
    var length;
    var total;

    if (showAllCategoriesSearchResults) {
      length = allCategoriesResultsLength;
      total = allCategoriesTotal;
    } else {
      length = searchResultsLength;
      total = searchResultsTotal;
    }

    return [length, total, Math.ceil(total / resultsPerPage)];
  }, [allCategoriesResultsLength, allCategoriesTotal, resultsPerPage, searchResultsLength, searchResultsTotal, showAllCategoriesSearchResults]),
      _useMemo4 = (0, _slicedToArray2.default)(_useMemo3, 3),
      resultsLength = _useMemo4[0],
      resultsTotal = _useMemo4[1],
      resultsPageCount = _useMemo4[2];

  var filtersHeadingI18nKey = (0, _react.useMemo)(function () {
    return getFiltersHeadingI18nKey(filters);
  }, [filters]);
  var renderedResultsHeading = (0, _react.useMemo)(function () {
    var headingKey;
    var headingOptions = {};

    if (searchValue) {
      headingKey = getI18nKey('headingText.searchResults');
    } else if (collection) {
      headingKey = (0, _i18n2.getCollectionI18nKey)(collection, 'headingText');
    } else if (superCategory || category) {
      headingKey = 'appMarketplace.storefront.filters.category.headingText';
      headingOptions = {
        category: (0, _strings.titlecase)((0, _unescapedText.default)(category ? (0, _i18n.getCategoryI18nKey)(category) : (0, _i18n.getSuperCategoryI18nKey)(superCategory)))
      };
    } else {
      headingKey = 'appMarketplace.storefront.filters.category.items.all.headingText';
    }

    return _react.default.createElement(_H.default, {
      className: "is--heading-2 m-bottom-0"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: headingKey,
      options: headingOptions
    }));
  }, [category, collection, searchValue, superCategory]);
  var renderedResultsCount = (0, _react.useMemo)(function () {
    if (!(0, _requestState.isFulfilled)(requestState)) {
      return null;
    }

    if (!(hasResults || showAllCategoriesSearchResults)) {
      return null;
    }

    var start = resultsTotal ? offset + 1 : 0;
    var end = Math.min(offset + resultsLength, resultsTotal);
    var total = Math.max(resultsTotal, resultsLength);

    var renderedCount = _react.default.createElement(_Big.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('resultsCount'),
      options: {
        start: start,
        end: end,
        total: total
      }
    }), ' ', searchValue && _react.default.createElement(_FormattedHTMLMessage.default, {
      message: getI18nKey('resultsCountSearchText'),
      options: {
        searchValue: searchValue,
        pageHeading: (0, _unescapedText.default)(filtersHeadingI18nKey)
      }
    }));

    if (searchValue && !hasResults) {
      return _react.default.createElement(_react.Fragment, null, renderedCount, _react.default.createElement("br", null), _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedJSXMessage.default, {
        message: getI18nKey('noResultsEmptyState.searchTitle_jsx'),
        elements: {
          b: 'b'
        },
        options: {
          searchValue: searchValue,
          pageHeading: (0, _unescapedText.default)(filtersHeadingI18nKey)
        }
      })));
    }

    return renderedCount;
  }, [filtersHeadingI18nKey, hasResults, offset, requestState, resultsLength, resultsTotal, searchValue, showAllCategoriesSearchResults]);
  var renderedResultsFilters = (0, _react.useMemo)(function () {
    var validFilterTagKeys = filters.getValidFilterTagKeys();

    if (validFilterTagKeys.isEmpty()) {
      return null;
    }

    return _react.default.createElement(_ResultsFilters.default, {
      filters: filters,
      onClearFilters: onClearFilters,
      onFilterChange: onFilterChange,
      trackInteraction: trackInteraction,
      validFilterTagKeys: validFilterTagKeys
    });
  }, [filters, onClearFilters, onFilterChange, trackInteraction]);
  var renderedSortDropdown = (0, _react.useMemo)(function () {
    if (!(hasResults || showAllCategoriesSearchResults)) {
      return null;
    }

    return _react.default.createElement(_SortDropdown.default, {
      filters: filters,
      onChange: function onChange(field, order) {
        onSortChange(field, order);
        trackInteraction('change sort', {
          sortField: field,
          sortOrder: order
        }, 'storefront-change-sort');
      }
    });
  }, [filters, hasResults, onSortChange, showAllCategoriesSearchResults, trackInteraction]);
  var renderedSupplementalResults = (0, _react.useMemo)(function () {
    if (!(0, _requestState.isSucceeded)(requestState) || !searchValue || restSupplementalResults.isEmpty()) {
      return null;
    }

    return restSupplementalResults.valueSeq().map(function (supplementalSearchResult, index) {
      return _react.default.createElement(SupplementalResultsSection, {
        key: "supplemental-results-" + index,
        onResultClick: function onResultClick(result, resultIndex) {
          return _onResultClick(result, resultIndex, supplementalSearchResult.items.size);
        },
        resultProps: resultProps,
        searchResult: supplementalSearchResult
      });
    }).toArray();
  }, [_onResultClick, requestState, restSupplementalResults, resultProps, searchValue]);
  var renderedPageContent = (0, _react.useMemo)(function () {
    if ((0, _requestState.isFailed)(requestState) && FailedComponent) {
      return _react.default.createElement(FailedComponent, null);
    }

    if ((0, _requestState.isSucceeded)(requestState) && !(hasResults || showAllCategoriesSearchResults)) {
      var renderedTitle = searchValue ? _react.default.createElement(_FormattedJSXMessage.default, {
        message: getI18nKey('noResultsEmptyState.searchTitle_jsx'),
        elements: {
          b: 'span'
        },
        options: {
          searchValue: searchValue,
          pageHeading: (0, _unescapedText.default)(filtersHeadingI18nKey)
        }
      }) : _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('noResultsEmptyState.filterTitle'),
        options: {
          pageHeading: (0, _unescapedText.default)(filtersHeadingI18nKey)
        }
      });
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ResultsSection.default, {
        gutterSize: "xl"
      }, _react.default.createElement(_H2.default, null, renderedTitle), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('noResultsEmptyState.message')
      }))), renderedSupplementalResults);
    }

    var renderedResultsGrid = _react.default.createElement(_ResultsGrid.default, {
      onResultClick: function onResultClick(result, index) {
        return _onResultClick(result, index, showAllCategoriesSearchResults ? allCategoriesResultsLength : searchResultsLength);
      },
      requestState: requestState,
      resultProps: resultProps,
      results: showAllCategoriesSearchResults ? allCategoriesResults : searchResults
    });

    var renderedResultsPagination = (0, _requestState.isSucceeded)(requestState) && resultsTotal > resultsLength ? _react.default.createElement(_UIPaginator.default, {
      onPageChange: handlePageChange,
      page: activePage,
      pageCount: resultsPageCount
    }) : null;
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ResultsSection.default, {
      ref: resultsRef
    }, renderedResultsGrid), _react.default.createElement(_ResultsSection.default, null, renderedResultsPagination));
  }, [FailedComponent, activePage, allCategoriesResults, allCategoriesResultsLength, filtersHeadingI18nKey, handlePageChange, hasResults, _onResultClick, renderedSupplementalResults, requestState, resultProps, resultsLength, resultsPageCount, resultsTotal, searchResults, searchResultsLength, searchValue, showAllCategoriesSearchResults]);
  var hasHeaderDetails = renderedResultsCount || renderedSortDropdown || renderedResultsFilters;
  var headerDetailsClasses = (0, _classnames.default)({
    hidden: !hasHeaderDetails
  });
  var headerDetailsGridClasses = (0, _classnames.default)({
    'm-bottom-4': !!((renderedResultsCount || renderedSortDropdown) && renderedResultsFilters)
  });

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scrollToResultsOpacity = _useState2[0],
      setScrollToResultsOpacity = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      scrollToResultsFixed = _useState4[0],
      setScrollToResultsFixed = _useState4[1];

  var detectResultsVisible = (0, _react.useCallback)(function () {
    var resultsEl = (0, _reactDom.findDOMNode)(resultsRef.current);
    var rect = resultsEl && resultsEl.getBoundingClientRect();

    if (rect) {
      setScrollToResultsFixed(resultsEl.parentElement.getBoundingClientRect().bottom > window.innerHeight);
      setScrollToResultsOpacity((_constants.NAV_BAR_HEIGHT_INT - rect.bottom) / 200);
    }
  }, [resultsRef]);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', detectResultsVisible);
    return function () {
      window.removeEventListener('scroll', detectResultsVisible);
    };
  }, [detectResultsVisible]);
  (0, _react.useEffect)(function () {
    // Update scroll to results visibility on re-render
    detectResultsVisible();
  });
  var scrollToTop = (0, _react.useCallback)(function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  var scrollToResults = (0, _react.useMemo)(function () {
    var resultsEl = (0, _reactDom.findDOMNode)(resultsRef.current);

    if (!resultsEl || searchResultsLength === 0) {
      return null;
    }

    return _react.default.createElement(_ScrollToResults.default, {
      containerWidth: resultsEl.offsetWidth,
      opacity: scrollToResultsOpacity,
      fixed: scrollToResultsFixed
    }, _react.default.createElement(_UIButton.default, {
      use: "link",
      onClick: scrollToTop
    }, _react.default.createElement(_UIIcon.default, {
      name: "next",
      size: "xs",
      style: {
        transform: 'rotate(-90deg)'
      }
    })), _react.default.createElement(_Big.default, {
      className: "display-block"
    }, _react.default.createElement(_FormattedJSXMessage.default, {
      message: getI18nKey('scrollToResults_jsx'),
      elements: {
        Link: _UIButton.default
      },
      options: {
        use: 'link',
        onClick: scrollToTop
      }
    })));
  }, [searchResultsLength, scrollToResultsOpacity, scrollToResultsFixed, scrollToTop]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_ResultsSection.default, null, renderedResultsHeading), _react.default.createElement(_AmplifyHeaderSection.default, {
    filters: filters
  }), _react.default.createElement(_ResultsSection.default, {
    className: headerDetailsClasses
  }, _react.default.createElement(_UIGrid.default, {
    className: headerDetailsGridClasses
  }, _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      lg: 8
    }
  }, renderedResultsCount), _react.default.createElement(_UIGridItem.default, {
    size: {
      xs: 12,
      lg: 4
    }
  }, renderedSortDropdown)), renderedResultsFilters), renderedPageContent, scrollToResults);
};

ResultsPage.propTypes = {
  activePage: _propTypes.default.number.isRequired,
  failedComponent: _propTypes.default.func,
  filters: CustomPropTypes.storefrontFilters.isRequired,
  offset: _propTypes.default.number,
  onClearFilters: _propTypes.default.func.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  onResultClick: _propTypes.default.func.isRequired,
  onSortChange: _propTypes.default.func.isRequired,
  requestState: CustomPropTypes.requestState.isRequired,
  resultProps: _propTypes.default.object,
  resultsPerPage: _propTypes.default.number,
  searchResult: _propTypes.default.instanceOf(_SearchResult.default).isRequired,
  supplementalResults: _reactImmutableProptypes.default.orderedSetOf(_propTypes.default.instanceOf(_SearchResult.default)).isRequired,
  trackInteraction: _propTypes.default.func.isRequired
};
ResultsPage.defaultProps = {
  offset: 0,
  resultProps: {},
  resultsPerPage: _constants.DEFAULT_SEARCH_LENGTH
};
var _default = ResultsPage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultsPage.js
// module id = 900
// module chunks = 209 210 211 212